import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {PaymentMethod} from '../../model/payment.model';
import {RefundCompletedDTO, RefundRequestDTO} from '../../model/refund.model';

export interface RefundStrategy {
  refund(request: RefundRequestDTO): Observable<RefundCompletedDTO>;
}

export interface RefundStrategyRegistry {
  resolve(method: PaymentMethod): RefundStrategy;
}

export const REFUND_STRATEGY_REGISTRY = new InjectionToken<RefundStrategyRegistry>('REFUND_STRATEGY_REGISTRY');
